export const INITIAL_FAS_REFERENCE_SELECTION_CAPTION = 'Anlagevermögen';
